module.exports = __webpack_public_path__ + "img/ad5.2161f3e5.jpg";